/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import "./svg-handler.m.css";

const getId = string => {
  try {
    return new URL(string).hash;
  } catch {
    return string ? "#" + get(string.split("#").reverse(), 0, "") : "#";
  }
};

export const SvgHandler = ({
  svgWrapperClazzName = "",
  clazzName = "",
  xlinkHref,
  invertColor,
  height = "50px",
  width = "50px",
  viewBox
}) => {
  const { symbol, viewBox: autoViewBox } = xlinkHref || {};
  if (!viewBox) {
    viewBox = autoViewBox === "undefined" ? "0 0 24 24" : autoViewBox;
  }
  const inlineStyles = {};
  if (invertColor) {
    inlineStyles.filter = "invert(100%)";
  }
  const svgId = symbol ? getId(symbol) : "";
  return (
    <div styleName={svgWrapperClazzName}>
      <svg height={height} width={width} className={`icon ${clazzName}`} viewBox={viewBox} style={inlineStyles}>
        <use xlinkHref={svgId} />
      </svg>
    </div>
  );
};

SvgHandler.propTypes = {
  svgWrapperClazzName: PropTypes.string,
  clazzName: PropTypes.string,
  viewBox: PropTypes.string,
  xlinkHref: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
  invertColor: PropTypes.string
};
